export const handleValidationError = (error, setErrorsState, errorsState) => {
  const status = error?.response?.status;
  const result = error?.response?.data?.result;

  if (status === 422 && result) {
    setErrorsState({ ...errorsState, ...result });
  } else {
    console.error('Unexpected error structure:', error);
  }
};